import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import config from '../../../../config';

/**
 * Project text input component.
 *
 * @param props {Object}.
 * @param props.field {String} Field name.
 * @param props.onTextChange {Function} Handle event of changing text.
 */
const ProjectTextInputComponent = ({ field, onTextChange }) => {
  const className = field.get('dirty') ? 'form-control dirty-field' : 'form-control';
  const type = config.values.getIn(['eproject', 'types', 'PROJECT']);

  return (
    <div className="form-group">
      <label className="field-label" htmlFor="projectCategoryInput">
        Project Name
      </label>
      <input
        className={className}
        id="projectCategoryInput"
        name="category"
        onChange={event => onTextChange({ event, data: { type } })}
        type="text"
        value={field.get('name')}
      />
    </div>
  );
};

ProjectTextInputComponent.propTypes = {
  field: PropTypes.instanceOf(Map).isRequired,
  onTextChange: PropTypes.func.isRequired,
};

export const ProjectTextInput = memo(ProjectTextInputComponent);
